export default {"src":"/_next/static/media/spyglass_64.3fa0acbe.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};